import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";

@Injectable()
export class IsNotReimbursementManagerGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate() {
    const currentUser = JSON.parse(localStorage.getItem("currentUser"));

    if (currentUser["roles"].includes("reimbursement_manager")) {
      window.alert("You don't have access to this page");
      this.router.navigate([`/account/${currentUser.id}/accountGoals`]);
      // this.router.navigate(["dashboard"]);
      return false;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/guards/isNot-reimbursement_manager.guard.ts